import axios from 'axios';
import swal from 'sweetalert';
import { AddUpdate, getData, getPostData, requestGet, requestPost } from '../ApiMethods/ApiMethods';

const baseURLS = window.location.origin === 'https://admin.astrocall.live'
  ? 'https://api.astrocall.live/api/'
  : 'https://liveapi.astrocall.live/api/';

const PERMISSION_API = `${baseURLS}ScreenPermissions/GetData_ScreenPermissionsUserBy`;

export async function fetchScreenPermission1(screenCode, userId) {
  try {
    const res = await requestPost(PERMISSION_API, { ScreenCode: screenCode  });
    return res?.data;
  } catch (err) {
    console.error('fetchScreenPermission error', err?.response || err);
    return { error: err?.response?.data || err?.message };
  }
}
export async function fetchScreenPermission(screenCode, userId) {
  try {
    const res = await requestPost(PERMISSION_API, { ScreenCode: screenCode , UserID: userId });
    return res?.data;
  } catch (err) {
    console.error('fetchScreenPermission error', err?.response || err);
    return { error: err?.response?.data || err?.message };
  }
}

export function showPermissionDeniedPopup(message) {
  swal('Access denied', message || 'आपके पास अनुमति नहीं है', 'error');
}


const MODULE_API = `${baseURLS}ScreenPermissions/GetData_Module`;
const SCREEN_API = `${baseURLS}ScreenPermissions/GetData_Screen`;
const INSERT_API = `${baseURLS}ScreenPermissions/Insert_ScreenPermissions`;

export async function fetchModules() {
  try {
   
    const res = await requestGet(MODULE_API, {});
    return res?.data;
  } catch (err) {
    console.error('fetchModules error', err?.response || err);
    return { error: err?.response?.data || err?.message };
  }
}

export async function fetchScreens(moduleId) {
  try {
    const res = await requestPost(SCREEN_API, { ModuleID: moduleId });
    return res?.data;
  } catch (err) {
    console.error('fetchScreens error', err?.response || err);
    return { error: err?.response?.data || err?.message };
  }
}

export async function insertScreenPermission(payload) {
  try {
    const res = await requestPost(INSERT_API, payload);
    return res?.data;
  } catch (err) {
    console.error('insertScreenPermission error', err?.response || err);
    return { error: err?.response?.data || err?.message };
  }
}
